module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "tasks"
    }
  }, [_c('md-content', {
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('div', {
    staticClass: "md-flex",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-table', {
    attrs: {
      "md-theme": "white"
    }
  }, _vm._l((_vm.modules), function(module, key) {
    return _c('md-table-row', {
      key: module.id
    }, [_c('md-table-cell', {
      staticClass: "name"
    }, [_c('router-link', {
      staticClass: "module",
      attrs: {
        "to": {
          name: 'Properties',
          params: {
            code: module.code
          },
          query: _vm.$route.query
        }
      }
    }, [_c('span', {
      staticClass: "md-layout-row md-gutter"
    }, [_c('span', {
      staticClass: "md-flex name"
    }, [_vm._v(_vm._s(module.description))])])])], 1), _c('md-table-cell', {
      staticClass: "load right"
    }, [_c('span', {
      staticClass: "md-layout-row md-gutter"
    }, [_c('span', {
      staticClass: "md-flex name"
    }, [_vm._v(_vm._s((module.load) ? 'Загружен' : 'Не загружен'))])])]), _c('md-table-cell', {
      staticClass: "active right"
    }, [_c('span', {
      staticClass: "md-layout-row md-gutter"
    }, [_c('span', {
      staticClass: "md-flex name"
    }, [_vm._v(_vm._s((module.active) ? 'Активен' : 'Не активен'))])])])], 1)
  }))], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7251c79e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/module/views/Overview.vue
// module id = 1188
// module chunks = 0